import { useGlobalContext } from '../context'

function FoolVampire() {
    const { players, index, voteForKill, vote, openWaitingScreen, turns } = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Vitaminless Vampire)</h4>
            <p className='text-center'>You are a vampire, but with a twist.Because you were fed milk instead of blood, unlike your normal vampires friends as a child, you grew weak.Now as a vitaminless
            vampire,you can't go no further than two rounds without killing someone.Otherwise, as you may have guessed...You will be dead.Good luck! </p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (player.class === 'vampire' || player.class === 'foolvampire' || player.class === 'dracula')
                            return (<button className='btn btn-danger border' disabled='disabled' key={index}>{player.name}</button>)
                        else 
                            return (<button disabled={vote ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-dark'} onClick={(e) => { voteForKill(index); e.target.classList.add('selected') }} key={index}>{`${player.name}(${player.voteCount})`}</button>)           
                          
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default FoolVampire;